import Icon from '../../../../../../../components/Icon'
import Button from "../../../../../../../components/Button";
import pencilIcon from "../../../../../../../assets/icons/pencil-bold.svg";
import {
  Flex
} from './styles'
import { useWindowSize } from '../../../../../../../hooks/useWindowSize';

const Component = ({ onClick }) => {
  const { isMobile } = useWindowSize()

  return (
    <Button
      onClick={onClick}
      options={{
        skin: 'black',
        type: 'outline',
        size: 'md',
      }}
      style={{
        color: "#2d3436",
        height: "40px",
        padding: "0px 12px",
        minWidth: 0,
        flexShrink: 0
      }}
    >
      <Flex style={{ gap: 4 }}>
        <Icon icon={pencilIcon} size="24px" color="#2d3436" />
        <span>Editar</span>
      </Flex>
    </Button>
  )
}

export default Component